module.exports = __webpack_public_path__ + "img/9b8bd2d.svg";